import { useUsersListTable } from "Settings/User/Components/Tables/Hooks/useUsersListTable";
import { PageContainer } from "Shared/Components/Container";
import { Table } from "Shared/Components/Table";

export const UsersPage = () => {
	const tableOptions = useUsersListTable();

	return (
		<PageContainer title="Users" description="User management">
			<Table tableOptions={tableOptions} />
		</PageContainer>
	);
};
